export default "__VITE_ASSET__Cyl2wa4g__"